import {of} from 'rxjs';
import {take, timeout, catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {AuthService} from "../services/AuthService";
import {defer, Observable, Subscription} from "rxjs";
import {NotificationService} from "../services/common/NotificationService";
import {BsModalRef} from "ngx-bootstrap/modal";
import {AuthenticatedUsersOnlyModalComponent} from "../areas/modals/authenticated-users-only-modal/authenticated-users-only-modal.component";
import {SiteConfigurationService} from "../services/SiteConfigurationService";
import {NGXLogger} from "ngx-logger";
import {PublishedResourceRepository} from "../services/repository/PublishedResourceRepository";
import {RoutingService} from "../services/RoutingService";

@Injectable({
	providedIn: 'root',
})
/**
 * Specifies whether a Draft can be edited or not
 */
export class PublicAccessPreferResourceCheckFirstBlockGuard implements CanActivate {

	private bsModalRef:BsModalRef;
	private subscriptions:Array<Subscription> = [];
    private next:ActivatedRouteSnapshot;
    private state:RouterStateSnapshot;

	constructor(private authService:AuthService,
	            private notificationService:NotificationService,
				private routingService:RoutingService,
	            private publishedResourceRepository:PublishedResourceRepository,
	            private siteConfigurationService:SiteConfigurationService,
				private router:Router,
				protected logger:NGXLogger) {
	}

	public canActivate(next:ActivatedRouteSnapshot, state:RouterStateSnapshot):Observable<boolean> {
		console.info("PuclicAccessBlockGuard::canActivate");
		let self = this;
        this.next = next; this.state = state;
		return defer(async function () {
			console.info("PuclicAccessBlockGuard::canActivate::async function ()");
			let shouldBlockAccess:boolean = self.siteConfigurationService.siteConfiguration.loginRequiredForSiteAccess;
			if(!shouldBlockAccess) {
				console.info("Not blocking access based on site access variable");
				return true;
			}

			console.info("self.authService.isAuthenticatingCurrently: " + self.authService.isAuthenticatingCurrently);

			//Is not a user currently WAITING for login
			let resourceGuid:string = next.params['resourceId']
			let isAPublicResource:boolean = await self.checkPublicResource(resourceGuid);
			console.info("Is a Public Resource...?" + isAPublicResource);

			if(isAPublicResource) {
				console.error("Is a Public Resource...ignoring other checks.")
				return true;
			}

            await self.authService.checkIfLoggedIn();
            return self.finishUpEitherWay(isAPublicResource);
		});
	}
	public finishUpEitherWay(isAPublicResource:boolean):boolean {
		let isAUser:boolean = this.authService.currentUser != null;
		if (isAUser) {
			console.info(`Welcome in ${this.authService.currentUser.guid}!`);
		} else if(!isAUser && isAPublicResource) {
			console.error("Hawt dog.  You got some access to a waihona resource without registering or logging in.");
		} else {
			console.error("It is invalid for anonymous user to access the site during the development phase.");
			if (this.routingService.getPreviousUrl() == undefined) {
				console.info("First navigation and not allowed..so navigating to location page.")
				this.router.navigateByUrl("/resources", {skipLocationChange:false});
			}
			this.bsModalRef = this.notificationService.displayModal(AuthenticatedUsersOnlyModalComponent, this);
		}
		return isAUser || isAPublicResource;
	}

    public async checkPublicResource(resourceGuid:string):Promise<boolean> {
        const resource = await this.publishedResourceRepository.get$(resourceGuid).pipe(
            take(1), timeout(10000), catchError(() => of(null))
        ).toPromise();
        return resource?.resourceSubmission?.configuration?.allowPublicAccess === true;
    }

	public clearSubscriptions():void {
		while(this.subscriptions.length > 0) {
			let s:Subscription = this.subscriptions.pop();
			s.unsubscribe();
		}

	}
	public destroyModal():void {
		this.bsModalRef.hide();
		delete this.bsModalRef;
	}

	public onClickLogin():void {
		console.info("Clicked Login");
		this.authService.login(this.state.url);
		this.destroyModal();
	}
	public onClickRegistration():void {
		console.info("Clicked Registration");
		this.router.navigate(["/user/register"]);
		this.destroyModal();
	}
	public onClickCancel():void {
		console.info("Clicked Cancel");
		this.destroyModal();
	}
}
